/**
 * Utility methods for Input.
 *
 * @class inputUtils
 * @static
 */
module.exports = {
  /**
   * Remove all input except numbers, commas, and periods by returning false which will stop the event propagation.
   * @param event {Event} the keypress event
   *   @param event.which {Number} the character code of the key pressed.
   * @return {Boolean} true if it's allowed number
   * @method sanitizeAmount
   */
  sanitizeAmount: function(event) {
    var charCode = event.which;
    var comma = 44;
    var period = 46;
    var lowNumber = 48;
    var highNumber = 57;
    var highControlKey = 31;
    var isAllowedSpecialCharacter = charCode === comma || charCode === period;
    var isNumber = charCode >= lowNumber && charCode <= highNumber;
    var isControlKey = charCode < highControlKey;
    return isAllowedSpecialCharacter || isNumber || isControlKey;
  },

  /**
   * Press ESC or Enter key to escape the input field
   * so the keyboard user can continue using arrow keys to navigate between options.
   *
   * @method escapeInputField
   * @param event {Event} the keyup event
   *   @param event.which {Number} the character code of the key pressed.
   *   @param event.target {Element} the input element that triggered the event.
   */
  escapeInputField: function(event) {
    var code = event.which;
    if ((code === 27) || (code === 13)) {
      $(event.target).parent().focus();
      return false;
    }
  }
};
